import { toReadableHours } from '../time';

const DEFAULT_START_TIME = toReadableHours(32400000);
const DEFAULT_END_TIME = toReadableHours(61200000);

const DEFAULT_START_AND_END_WORKING_TIMES = [{ start: DEFAULT_START_TIME, end: DEFAULT_END_TIME }];

export const DEFAULT_WORKING_DAYS = {
	monday: DEFAULT_START_AND_END_WORKING_TIMES,
	tuesday: DEFAULT_START_AND_END_WORKING_TIMES,
	wednesday: DEFAULT_START_AND_END_WORKING_TIMES,
	thursday: DEFAULT_START_AND_END_WORKING_TIMES,
	friday: DEFAULT_START_AND_END_WORKING_TIMES,
} as const;

export const DEFAULT_CALENDAR_DATA = {
	id: undefined,
	name: '',
	timezoneId: undefined,
	holidays: undefined,
	workingTimes: DEFAULT_WORKING_DAYS,
} as const;
